import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Item } from 'app/menu/models/menu.model';

@Injectable({ providedIn: 'root' })
export class DescriptionParserService {
  constructor(private sanitizer: DomSanitizer) { }

  parse(
    text: string | undefined,
    maxLength?: number
  ): SafeHtml {
    if (!text) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    let truncated = text;

    if (maxLength && text.length > maxLength) {
      truncated = text.slice(0, maxLength) + '...';
    }

    let html = truncated;

    html = html.replace(
      /\[\[dot:([\w-]+)\]\]/g,
      (_, color) => `<span class="dot dot-${color}"></span>`
    );

    html = html.replace(/\[\[br\]\]/g, '<br>');

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getParsedDescription(item: Item, lang: 'ES' | 'EN') {
    return lang === 'ES'
      ? this.parse(item.description)
      : this.parse(item.descriptionEn);
  }
}
